import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import {
  FieldVisibility_HIDDEN_getInstance2bb3agz7xywku as FieldVisibility_HIDDEN_getInstance,
  FieldVisibility_READ_getInstancekx1pgmq3g1h as FieldVisibility_READ_getInstance,
  FieldVisibility_EDIT_getInstancek1g4gozfl4h as FieldVisibility_EDIT_getInstance,
} from './Annotations.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mutableMapOfk2y3zt1azl40 as mutableMapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  minOrNull1g8m0136x75mg as minOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { serialNameFQN3cassnowfodm5 as serialNameFQN } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/SerialDescriptor.ext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Renderer1fhwti5gmwutm as Renderer } from './Renderer.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import {
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_editIconv23ytngmqu3s as get_editIcon } from './extra-icons.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_atTopEnd2f4khbhwy0qa as get_atTopEnd } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function FormModule$typeInfo$lambda(it) {
  return null;
}
function FormModule$selectionKey$lambda(it) {
  return it.fqn_1;
}
function FormModule$defaultCellForm$lambda$slambda($$this$button, $renderer, $context, $value, this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, _unused_var__etf5q3) => {
      $renderer.form_gie6yk_k$($context, $value, this$0)($this$dialog);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
function FormModule$labeledFormWithSwitcher$lambda$lambda(it) {
  return it.get_name_woqyms_k$();
}
function FormModule$labeledViewWithSwitcher$lambda$lambda(it) {
  return it.get_name_woqyms_k$();
}
var FormModuleClass;
function FormModule() {
  if (FormModuleClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.renderers_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.fileUpload_1 = null;
        var tmp_0 = this;
        tmp_0.typeInfo_1 = FormModule$typeInfo$lambda;
        this.serializersModule_1 = EmptySerializersModule();
        this.visibilitySettings_1 = mutableMapOf([to('com.lightningkite.services.data.AdminHidden', FieldVisibility_HIDDEN_getInstance()), to('com.lightningkite.services.data.Denormalized', FieldVisibility_READ_getInstance()), to('com.lightningkite.services.data.AdminViewOnly', FieldVisibility_READ_getInstance())]);
        this.enableRendererSwitching_1 = false;
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.rendererSelections_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      }
      effectiveVisibility_ilul0q_k$(context) {
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = context.get_allAnnotations_5zk630_k$();
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp0_safe_receiver = this.visibilitySettings_1.get_wei43m_k$(element.fqn_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.add_utx5q5_k$(tmp0_safe_receiver);
          }
        }
        var annotationVisibility = minOrNull(destination);
        var isUuidId = serialNameFQN(context.serializer_1.get_descriptor_wjt6a0_k$()) === 'com.lightningkite.Uuid' && !context.hasAnnotation_cpsd4h_k$('com.lightningkite.services.data.References') && !context.hasAnnotation_cpsd4h_k$('com.lightningkite.services.data.MultipleReferences');
        var tmp;
        if (annotationVisibility == null) {
          var tmp_0;
          if (isUuidId) {
            var tmp1_elvis_lhs = this.visibilitySettings_1.get_wei43m_k$('com.lightningkite.services.data.AdminHidden');
            tmp_0 = tmp1_elvis_lhs == null ? FieldVisibility_HIDDEN_getInstance() : tmp1_elvis_lhs;
          } else {
            tmp_0 = FieldVisibility_EDIT_getInstance();
          }
          tmp = tmp_0;
        } else {
          tmp = annotationVisibility;
        }
        return tmp;
      }
      selectionKey_lizmjk_k$(context) {
        var typeName = context.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        var annotations = joinToString(context.fieldAnnotations_1, ',', VOID, VOID, VOID, VOID, FormModule$selectionKey$lambda);
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(annotations) === 0) {
          tmp = typeName;
        } else {
          tmp = typeName + '|' + annotations;
        }
        return tmp;
      }
      selectAll_bhj9zi_k$(context) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.renderers_1;
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var selector = element.component1_7eebsc_k$();
          if (selector.matches_1u0b5c_k$(context)) {
            destination.add_utx5q5_k$(element);
          }
        }
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination, 10));
        var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s_0.next_20eer_k$();
          var renderer = item.component2_7eebsb_k$();
          var tmp$ret$5 = isInterface(renderer, Renderer()) ? renderer : THROW_CCE();
          destination_0.add_utx5q5_k$(tmp$ret$5);
        }
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_1 = destination_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
          if (element_0.priority_yxj3hb_k$(context, this) >= 0.0) {
            destination_1.add_utx5q5_k$(element_0);
          }
        }
        // Inline function 'kotlin.collections.sortedByDescending' call
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp = (a, b) => {
          // Inline function 'kotlin.comparisons.compareValuesBy' call
          var tmp = b.priority_yxj3hb_k$(context, this);
          var tmp$ret$13 = a.priority_yxj3hb_k$(context, this);
          return compareValues(tmp, tmp$ret$13);
        };
        var tmp$ret$10 = new (sam$kotlin_Comparator$0())(tmp);
        return sortedWith(destination_1, tmp$ret$10);
      }
      selectWithOverride_muco3f_k$(context) {
        if (!this.enableRendererSwitching_1)
          return this.select_mv5knr_k$(context);
        var key = this.selectionKey_lizmjk_k$(context);
        var tmp = this.rendererSelections_1.get_wei43m_k$(key);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Renderer()) : false) ? tmp : null;
        return tmp0_elvis_lhs == null ? this.select_mv5knr_k$(context) : tmp0_elvis_lhs;
      }
      register_9awv9l_k$(selector, renderer) {
        this.renderers_1.add_utx5q5_k$(to(selector, renderer));
      }
      select_mv5knr_k$(context) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.renderers_1;
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var selector = element.component1_7eebsc_k$();
          if (selector.matches_1u0b5c_k$(context)) {
            destination.add_utx5q5_k$(element);
          }
        }
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.maxByOrNull' call
          var iterator = destination.iterator_jk1svi_k$();
          if (!iterator.hasNext_bitz1p_k$()) {
            tmp$ret$3 = null;
            break $l$block_0;
          }
          var maxElem = iterator.next_20eer_k$();
          if (!iterator.hasNext_bitz1p_k$()) {
            tmp$ret$3 = maxElem;
            break $l$block_0;
          }
          var renderer = maxElem.component2_7eebsb_k$();
          var maxValue = (isInterface(renderer, Renderer()) ? renderer : THROW_CCE()).priority_yxj3hb_k$(context, this);
          do {
            var e = iterator.next_20eer_k$();
            var renderer_0 = e.component2_7eebsb_k$();
            var v = (isInterface(renderer_0, Renderer()) ? renderer_0 : THROW_CCE()).priority_yxj3hb_k$(context, this);
            if (compareTo(maxValue, v) < 0) {
              maxElem = e;
              maxValue = v;
            }
          }
           while (iterator.hasNext_bitz1p_k$());
          tmp$ret$3 = maxElem;
        }
        var tmp0_safe_receiver = tmp$ret$3;
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.second_1;
        var tmp1_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Renderer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No renderer for ' + context.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        return tmp_0;
      }
      form_gqhwsi_k$(context, value) {
        return this.select_mv5knr_k$(context).form_gie6yk_k$(context, value, this);
      }
      view_ntgxjz_k$(context, value) {
        return this.select_mv5knr_k$(context).view_bqdmap_k$(context, value, this);
      }
      cellView_ngep41_k$(context, value) {
        return this.select_mv5knr_k$(context).cellView_2dvin1_k$(context, value, this);
      }
      columnWidth_g5mvjx_k$(context) {
        return this.select_mv5knr_k$(context).columnWidth_ilfqwj_k$(context, this);
      }
      defaultCellForm_qf3kck_k$(context, value, renderer) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Frame())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          renderer.cellView_2dvin1_k$(context, value, this)(element_0);
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_1 = get_unpadded(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = get_editIcon();
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (IconView())(element_1.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          element_1.willAddChild_hz2iwc_k$(element_2);
          element_2.set_source_3o5lkf_k$(icon);
          element_2.set_description_s1386w_k$('Edit');
          element_2.onStartup_vrxh3i_k$();
          element_1.addChild_2qpft2_k$(element_2);
          onClick(element_1, VOID, VOID, VOID, FormModule$defaultCellForm$lambda$slambda(element_1, renderer, context, value, this));
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledFormWithSwitcher_1jpbbj_k$(context, value, label, description) {
        var renderers = this.selectAll_bhj9zi_k$(context);
        var selectedRenderer = this.selectWithOverride_muco3f_k$(context);
        if (!this.enableRendererSwitching_1) {
          return selectedRenderer.labeledForm_ughtr2_k$(context, value, this, label, description);
        }
        var key = this.selectionKey_lizmjk_k$(context);
        return (_this__u8e3s4) => {
          var selected = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(selectedRenderer);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Frame())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var $this$frame = element_0;
          reactive($this$frame, VOID, ($this$reactive) => {
            $this$frame.clearChildren_eufjq4_k$();
            $this$reactive.invoke_r7m7el_k$(selected).labeledForm_ughtr2_k$(context, value, this, label, description)($this$frame);
            return Unit_instance;
          });
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(sizeConstraints(get_atTopEnd(element), VOID, VOID, VOID, VOID, VOID, get_rem(0.75)), SubtextSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          var tmp = _Constant___init__impl__v45mub(renderers);
          element_1.bind_64a41i_k$(selected, new (Constant())(tmp), FormModule$labeledFormWithSwitcher$lambda$lambda);
          selected.addListener_6y9mct_k$(() => {
            var tmp0 = this.rendererSelections_1;
            var tmp2 = key;
            // Inline function 'kotlin.collections.set' call
            var value = selected.get_value_j01efc_k$();
            tmp0.put_4fpzoq_k$(tmp2, value);
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledViewWithSwitcher_k209xo_k$(context, value, label, description) {
        var renderers = this.selectAll_bhj9zi_k$(context);
        var selectedRenderer = this.selectWithOverride_muco3f_k$(context);
        if (!this.enableRendererSwitching_1 || renderers.get_size_woubt6_k$() <= 1) {
          return selectedRenderer.labeledView_aldyvt_k$(context, value, this, label, description);
        }
        var key = this.selectionKey_lizmjk_k$(context);
        return (_this__u8e3s4) => {
          var selected = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(selectedRenderer);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Frame())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Frame())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var $this$frame = element_0;
          reactive($this$frame, VOID, ($this$reactive) => {
            $this$frame.clearChildren_eufjq4_k$();
            $this$reactive.invoke_r7m7el_k$(selected).labeledView_aldyvt_k$(context, value, this, label, description)($this$frame);
            return Unit_instance;
          });
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(sizeConstraints(get_atTopEnd(element), VOID, VOID, VOID, VOID, VOID, get_rem_0(8)), SubtextSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          var tmp = _Constant___init__impl__v45mub(renderers);
          element_1.bind_64a41i_k$(selected, new (Constant())(tmp), FormModule$labeledViewWithSwitcher$lambda$lambda);
          selected.addListener_6y9mct_k$(() => {
            var tmp0 = this.rendererSelections_1;
            var tmp2 = key;
            // Inline function 'kotlin.collections.set' call
            var value = selected.get_value_j01efc_k$();
            tmp0.put_4fpzoq_k$(tmp2, value);
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($, 'FormModule', FormModule);
    FormModuleClass = $;
  }
  return FormModuleClass;
}
//region block: exports
export {
  FormModule as FormModule1vzulytb0ryex,
};
//endregion

//# sourceMappingURL=FormModule.mjs.map
